module.exports = __webpack_public_path__ + "img/1458295058.5d8ae622.jpg";